/**
 *  实现功能
 *  1、默认情况下只禁止空格输入
 *  2、限制只能输入整数
 *  3、限制只能输入整数和小数（价格类）
 *  4、限制只能输入手机号
 *  5、限制最大值和最小值(抛出错误给回调函数)
 */
const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, false)
  el.dispatchEvent(e)
}
const addListener = function (el, type, fn) {
  el.addEventListener(type, fn, false)
}
const spaceFilter = function (el) {
  addListener(el, 'keyup', () => {
    el.value = el.value.replace(/\s+/, '')
    trigger(el, 'input')
  })
}
const numberWordFilter = function (el) {
  addListener(el, 'keyup', () => {
    var str = el.value.replace(/[^\w\-\/]/ig, '');
    if (str != el.value) {
      el.value = str
    }
    trigger(el, 'input')
  })
}
const intFilter = function (el) {
  addListener(el, 'keyup', () => {
    var str = el.value.replace(/\D/g, '');
    if (str != el.value) {
      el.value = str
    }
    trigger(el, 'input')
  })

}
const priceFilter = function (el) {
  addListener(el, 'keyup', () => {
    var str = el.value.replace(/[^\d.]/g, "").
    //只允许一个小数点              
    replace(/^\./g, "").replace(/\.{2,}/g, ".").
    //只能输入小数点后两位
    replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    if (isNaN(str)) {
      str = ''
    }
    if (str != el.value) {
      el.value = str
    }
    trigger(el, 'input')
  })
}
const specialFilter = function (el) {
  addListener(el, 'keyup', () => {
    el.value = el.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '')
  })
}
const phoneFilter = function (el) {
  addListener(el, 'blur', () => {
    if (!el.value) {
      return
    }
    const phoneReg = new RegExp('^(13|14|15|16|17|18|19)[0-9]{9}$')
    if (!phoneReg.test(el.value)) {
      alert('手机号输入错误')
      el.value = ''
    }
    trigger(el, 'input')
  })
}
const urlFilter = function (el) {
  addListener(el, 'blur', () => {
    if (!el.value) {
      return
    }
    const urlReg = /(^#)|(^http(s*):\/\/[^\s]+\.[^\s]+)/
    if (!urlReg.test(el.value)) {
      alert('url输入错误')
      el.value = ''
    }
  })
}
export default {
  bind(el, binding) {
    if (el.tagName.toLowerCase() !== 'input') {
      el = el.getElementsByTagName('input')[0]
    }
    spaceFilter(el)
    switch (binding.arg) {
      case 'int':
        intFilter(el)

        break
      case 'price':
        priceFilter(el)
        break
      case 'special':
        specialFilter(el)
        break
      case 'phone':
        phoneFilter(el)
        break
      case 'url':
        urlFilter(el)
        break
      case 'numberWord':
        numberWordFilter(el)
        break
      default:
        break
    }
  }
}
